import { toFolder } from './folder';
import { MediaType } from '../../../constants/MediaType';
const EDITOR3_FLAT_STRUCTURE_TAG = 'root_v2';

// editor3/wixel categories are different from old ones from public media
// old ones look like this: "Images" => "Images" => All Images
// editor3/wixel ones look like this: "Images" => All Images
// to make it compatible, new roots have tag on it
// and media manager just add same folder twice if it sees this tag
// making it look like old structure
export const mapFoldersToTree = (folders, parentId) => {
  return folders.reduce((treeCategories, category) => [...treeCategories, {
    ...toFolder(category, parentId),
    subFolders: mapFoldersToTree((category.systemTags || []).includes(EDITOR3_FLAT_STRUCTURE_TAG) ? [{
      ...category,
      systemTags: category.systemTags.filter(tag => tag !== EDITOR3_FLAT_STRUCTURE_TAG)
    }] : category.children, category.guid)
  }], []);
};
const enterpriseMediaTypesToMediaTypes = {
  IMAGE: MediaType.Picture,
  VIDEO: MediaType.Video,
  VECTOR: MediaType.Shape,
  DOCUMENT: MediaType.Document,
  AUDIO: MediaType.Music,
  ARCHIVE: MediaType.Archive,
  MIXED: MediaType.Document,
  MODEL3D: MediaType.ThreeD
};
export const mapEnterpriseCategories = _ref => {
  let {
    category,
    subCategories
  } = _ref;
  return {
    guid: category.id,
    title: category.displayName,
    mediaType: enterpriseMediaTypesToMediaTypes[category.mediaType],
    systemTags: [],
    children: (subCategories || []).map(mapEnterpriseCategories)
  };
};